import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, o = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#000",
  d: "M5.858 34.142a20.123 20.123 0 0 0 2.673 2.246L36.388 8.531a20.107 20.107 0 0 0-4.919-4.919L3.612 31.47a20.124 20.124 0 0 0 2.246 2.673Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#6DA544",
  d: "M5.858 5.858c-6.31 6.31-7.521 15.785-3.636 23.312L29.17 2.222C21.643-1.663 12.167-.452 5.858 5.858Z"
}, null, -1), a = /* @__PURE__ */ t("path", {
  fill: "#338AF3",
  d: "M34.142 34.142c6.31-6.31 7.52-15.786 3.636-23.312L10.83 37.778c7.526 3.885 17.002 2.674 23.312-3.636Z"
}, null, -1), i = [
  o,
  c,
  s,
  a
];
function d(_, h) {
  return e(), l("svg", n, [...i]);
}
const f = { render: d };
export {
  f as default,
  d as render
};
